import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function useCreateUser() {
  const backend_url = process.env.REACT_APP_BACKEND_URL;
  const { authState, setAuthState } = useContext(AuthContext);
  let target = `${backend_url}/auth/register`;

  //id, status, remarks
  const [data, setData] = useState();

  const [res, setRes] = useState({
    data: null,
    complete: false,
    loading: false,
    error: false,
  });

  useEffect(() => {
    if (!data) return;
    setRes({
      data: null,
      loading: true,
      error: false,
      complete: false,
    });
    axios({
      url: target,
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
      },
    })
      .then((res) =>
        setRes({
          data: res.data,
          loading: false,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        setRes({
          data: null,
          loading: false,
          error: true,
          errorMessage: e,
          complete: true,
        });
      });
  }, [data]);

  return [res, setData];
}
